// Module
var code = "<div class=\"wtsim\"> <h1 class=\"wtsim-title\">{{TITLE}}</h1> <p class=\"wtsim-desc\">{{DESCRIPTION}}</p> <div class=\"wtsim-global-map\"> <div class=\"wtsim-map\"> {{&GLOBAL_MAP}} <span class=\"wtsim-name-tag\">Global Map</span> </div> {{&CHILD_MAPS}} </div> <div class=\"wtsim-global-content wtsim-content\"> {{CONTENT}} </div> </div>";
// Exports
module.exports = code;